// src/components/PrivateRoute/PrivateRoute.js
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import { getUser, getToken } from "../../services/authService";

const PrivateRoute = ({ children, requiredRole }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    userRole: null,
    loading: true,
  });

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = getToken();
        const user = getUser();

        if (token && user && user.role) {
          setAuthState({
            isAuthenticated: true,
            userRole: user.role,
            loading: false,
          });
        } else {
          setAuthState({
            isAuthenticated: false,
            userRole: null,
            loading: false,
          });
        }
      } catch (error) {
        console.error("Auth check error:", error);
        setAuthState({
          isAuthenticated: false,
          userRole: null,
          loading: false,
        });
      }
    };

    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, []);

  const { isAuthenticated, userRole, loading } = authState;

  if (loading) {
    return (
      <div className="loading-container">
        <OrbitLoaderComponent size="medium" showPath={true} color="white" />
        <p>Kontrol ediliyor...</p>
      </div>
    );
  }

  if (!isAuthenticated || !userRole) {
    return <Navigate to="/login" replace />;
  }

  // maintenance_admin rolü özel kontrolü
  if (userRole.toLowerCase() === "maintenance_admin") {
    // maintenance_admin her yere erişebilir
    return children;
  }

  // Diğer roller için standart kontrol
  if (userRole.toLowerCase() !== requiredRole.toLowerCase()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
